import { useCallback } from "react";

/**
 * Handles Age Preferences selection with "All Ages" mutual exclusivity:
 * - Selecting "All Ages" clears other options
 * - Selecting another option when "All Ages" is selected removes "All Ages"
 */
export const useAgePreferencesSelection = (currentValue, onUpdate) => {
  return useCallback(
    (selected) => {
      const prev = Array.isArray(currentValue) ? currentValue : [];
      const allAgesJustSelected =
        selected.includes("All Ages") && !prev.includes("All Ages");
      const otherJustSelected =
        selected.length > prev.length && !allAgesJustSelected;

      let newValue;
      if (allAgesJustSelected) {
        newValue = ["All Ages"];
      } else if (otherJustSelected && selected.includes("All Ages")) {
        newValue = selected.filter((v) => v !== "All Ages");
      } else {
        newValue = selected;
      }

      onUpdate("agePreferences", newValue);
    },
    [currentValue, onUpdate]
  );
};
